module.exports = "/_next/static/images/cbe8f9c266c05b10d8c390c8e41b37af-image-left-xs.jpg.webp";